<!--
 * @Author: fengzhongmei
 * @Date: 2020-06-15 14:12:46
 * @LastEditors: fengzhongmei
 * @LastEditTime: 2020-06-16 15:32:50
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
-->
<template>
    <!--点击服务管理的更多按钮组件 -->
    <div class="dropdownlist"
         style="padding-left: 8px;text-align:left">
        <Dropdown trigger="click"
                  @on-click='func'
                  :transfer="true"
                  placement="bottom-end">
            <a href="javascript:void(0)">
                {{$t('更多')}}
                <Icon type="md-arrow-dropdown" />
            </a>
            <DropdownMenu slot="list">
                <template v-for="item in JSON.parse(operateConfig).filter(o => o.display)">
                    <Dropdown v-if="item.children"
                              :key="item.value"
                              trigger="hover"
                              @on-click='func'
                              :transfer="true"
                              placement="bottom-end"
                              style="padding: 5px 16px">
                        <a href="javascript:void(0)">
                            {{item.btnName}}
                            <Icon type="md-arrow-dropdown" />
                        </a>
                        <DropdownMenu slot="list">
                            <DropdownItem v-for="citem in item.children.filter(c => c.display)"
                                          :key="citem.value"
                                          :name="citem.value"
                                          :divided="citem.divided"
                                          :disabled="citem.disabled">
                                <i :class="citem.btnIcon"
                                   class="mar-right5"></i>
                                <span v-if="citem.tips">
                                    <Tooltip placement="right"
                                             :transfer="true"
                                             theme='light'>
                                        <span>{{citem.btnName}}</span>
                                        <div slot="content">
                                            <div v-html='citem.tips'></div>
                                        </div>
                                    </Tooltip>
                                </span>
                                <span v-else>{{citem.btnName}}</span>
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>

                    <DropdownItem v-else
                                  :key="item.value"
                                  :name="item.value"
                                  :divided="item.divided"
                                  :title="item.title"
                                  :disabled="item.disabled">
                        <i :class="item.btnIcon"
                           class="mar-right5"></i>
                        <!-- <span>{{item.btnName}}</span> -->
                        <span v-if="item.tips">
                            <Tooltip placement="right"
                                     :transfer="true"
                                     theme='light'>
                                <span>{{item.btnName}}</span>
                                <div slot="content">
                                    <div v-html='item.tips'></div>
                                </div>
                            </Tooltip>
                        </span>
                        <span v-else>{{item.btnName}}</span>
                    </DropdownItem>
                </template>
            </DropdownMenu>
        </Dropdown>
    </div>
</template>
<script>
export default {
    name: 'dropdownlist',
    props: ['operateConfig', 'event'],
    data () {
        return {
            deleteId: ''
        }
    },
    methods: {
        func: function (name) {
            this.$emit('event', name)
        }
    }
}
</script>
<style  lang="less" >
.dropdownlist {
    padding-left: 8px;
    .ivu-dropdown-item:hover {
        color: #2b85e4;
    }
    .ivu-dropdown-item.ivu-dropdown-item-disabled:hover {
        color: #c5c8ce;
    }
}
</style>
